import {filterService} from "@/modules/filters/services/filterService";

const get = (business_id) => {
  return filterService.get(business_id, 'booking');
};

export const bookingFilterService = {
  get
};
